import { all } from 'redux-saga/effects';
import leaveApprovalWatcher from './leave-approval-saga';

export default function* rootSaga(action) {
	yield all([leaveApprovalWatcher(action)]);
}
